import { useIntl } from "react-intl";
import { Modal, Box, Typography } from "@mui/material";
import PageHeader from "../ui/PageHeader";

const NoteModal = (props) => {
  const modalStyle = {
    position: "relative",
    top: "20%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: 500,
    p: 4,
    borderRadius: "5px",
  };

  const handleClose = () => {
    props.handleCloseModal();
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={props.modalNoteHeader} />
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {props.modalNoteContent}
        </Typography>
      </Box>
    </Modal>
  );
};

export default NoteModal;
